module.exports = `${require.publicPath}platform-admin.c7b383f2.png`;